export class StudentRoom {

    constructor(
        public tempId: number,
        public name: string
    ){}
}
